package com.kelimesoft.etutpro.pages.sinif

enum class SnfPage{
    Ozet,
    Etut
}